import { Currency } from '@/core/currency/interfaces';

const FKP: Currency = {
    name: 'Falkland Islands Pound',
    demonym: 'Falkland Islands',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '238',
    symbol: 'FK£',
    symbolNative: '£',
    minorSingle: 'Penny',
    minorPlural: 'Pence',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'FKP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default FKP;
